module.exports = __webpack_public_path__ + "img/kv_img_4.bbf1b6f3.png";